import React from 'react'
import { Header } from '../../Header'
import { Image } from '../Image'

export const Container = () => [
  <Header key='header'>Logo</Header>,
  <Image key='image' />
]

Container.displayName = 'Logo'
